import React from "react";
function Img(props){
    return (<div>
 <img src={props.adr} alt="" class="about-img"/>
    </div>);
}

export default Img;
